<template>
    <div v-if="headerSearchSlice" class="keyword-search-banner" data-testid="search-banner">
        <HeaderSearchSlice :slice="headerSearchSlice" :index="0" :slices="[headerSearchSlice]" :context="{}" />
    </div>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {usePrismicDocument} from '@navbar-unlogged/composables';
    import HeaderSearchSlice from '@navbar-unlogged/slices/HeaderSearchSlice/index.vue';
    import type {SharedSlice} from '@prismicio/types';
    import type {HeaderSearchSliceSlice} from '@prismicio-types';
    import {useAsyncData, usePrismicLang} from '#imports';

    const {lang} = usePrismicLang();
    const {data: navbar} = await useAsyncData('malt-header', () => usePrismicDocument('malt-header', lang.value), {deep: true});

    const headerSearchSlice = computed(
        () =>
            (navbar.value?.data?.slices as SharedSlice[] | undefined)?.find((slice) => slice.slice_type === 'header_search_slice') as
                HeaderSearchSliceSlice | undefined,
    );
</script>

<style lang="scss" scoped>
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .keyword-search-banner {
        display: none;

        @include mq.screen_md(min) {
            display: block;
            position: sticky;
            top: var(--navbar-height, 60px);
            z-index: 999;
            width: 100%;
            margin: 0;
            padding: 0;
            background-color: var(--joy-color-background-default);
            border-bottom: solid 1px var(--joy-color-neutral-30);
        }
    }
</style>
